import { Eyebrow, Reveal } from "@/components/Reveal";
import AppCard from "@/components/AppCard";
import { APPS } from "@/lib/content";

export default function QuickAccess() {
  return (
    <section id="quick-access" className="relative bg-[#FFFFFF] py-24 lg:py-32" data-testid="quick-access-section">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <Eyebrow>Client Quick Access</Eyebrow>
            <h2 className="mt-4 max-w-lg font-display text-4xl font-medium leading-tight tracking-tight text-[#102036] sm:text-5xl">
              Your secure portals, one click away.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-[#4A5568]">
            Existing clients can sign in to our separate secure applications. They open in a new tab —
            we never ask for your portal credentials on this website.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          <Reveal delay={0.05}>
            <AppCard app={APPS.clientManager} large testid="quick-access-client-manager-card" />
          </Reveal>
          <Reveal delay={0.15}>
            <AppCard app={APPS.taxManager} large testid="quick-access-tax-manager-card" />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
